// extracted by mini-css-extract-plugin
module.exports = {"form":"src-_components-___UserPreferencesEditForm-module__form___17_sv"};